import React from 'react';
import { ModalHeader as BaseModalHeader, ModalCloseBtn } from '@fiverr-private/overlay';

const ModalHeader = ({ withCloseButton, children, ...props }) => {
    if (withCloseButton) {
        return (
            <BaseModalHeader {...props}>
                {children}
                <ModalCloseBtn />
            </BaseModalHeader>
        );
    }
    return <BaseModalHeader {...props}>{children}</BaseModalHeader>;
};

export default ModalHeader;
